import React from "react";
import ReactExport from "react-data-export";
import { DialogContent } from "@material-ui/core";

const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;

function ExcelExport(props) {
  const columns = props.columns;
  const data = props.data;
  return (
    <>
      <DialogContent>
        <div>
          <ExcelFile hideElement={true}>
            <ExcelSheet data={data} name="sheet1">
              {columns.map((column) => {
                return <ExcelColumn label={column.label} value={column.key} />;
              })}
            </ExcelSheet>
          </ExcelFile>
        </div>
      </DialogContent>
    </>
  );
}

export default ExcelExport;
